//import ProcDes                        from '../FormDesigner/ProcessDesigner';

import PhysitrackSettings from "./PhysitrackSettings";
import TeamGroupSettings from "./TeamGroupSettings";
import RotaTypeGroupSettings from "./RotaTypeGroupSettings";
import AppointmentTypeGroupSettings from "./AppointmentTypeGroupSettings";

/*
 * REACT Component to allow the user to configure system settings
 */

const Settings = ({ state, eventDispatch}) =>  {

    return <div>
        <PhysitrackSettings {...{ state, eventDispatch }} />
        <TeamGroupSettings {...{ state, eventDispatch }} />
        <RotaTypeGroupSettings {...{ state, eventDispatch }} />
        <AppointmentTypeGroupSettings {...{ state }} />
    </div>
}

export default Settings;